module.exports = __webpack_public_path__ + "static/img/s15.ca0181c8.png";